<div class="pad15 withpopupCard card">
    <div class="row">
        <div class="font16 fontbold ml-auto mr-3">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}
            <span class="font16 fontnormal" translate>lblResults</span>
        </div>
    </div>
  </div>
<!-- bg-grey -->
<div class=" scrollbar dwo">
    <div class="card mb15">
      <div class="table-responsive max-h265"
      infinite-scroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown($event)" >
            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 7%" scope="col" translate>lblOwnerType</th>
                        <th style="width: 18%" scope="col" translate>lblName</th>
                        <th style="width: 15%" scope="col" translate>lblFromDate</th>
                        <th style="width: 25%" scope="col" translate>lblToDate</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="vehicleOwnershipHistoryList?.length>0; else load_else">
                        <tr *ngFor="let voh of vehicleOwnershipHistoryList; let i=index">
                            <td>
                                <ngb-highlight [result]="voh.ownerType">{{voh.ownerType}}
                                </ngb-highlight>
                            </td>
                             <td>
                                <ngb-highlight [result]="voh.name">{{voh.name}}
                                </ngb-highlight>
                            </td> 
                            <td>
                                <ngb-highlight [result]="voh.fromDate | date:'shortDate'">
                                </ngb-highlight>
                            </td>
                            <td *ngIf="voh.toDate != null; else load_nullDate">
                                <ngb-highlight [result]="voh.toDate | date:'shortDate'">
                                </ngb-highlight>
                            </td>
                            <ng-template #load_nullDate>
                            <td>
                                -
                            </td>
                        </ng-template>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
      </div>
    </div>  
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg mb-1" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
    </div>
</div>
